var nnip = {
    'classes': {}
	};

nnip.classes.getUrlParams = function() {
	//Returns a object where the key is the parameter caller and the value is the parameter value
	var urlParams;
	var match,
		pl = /\+/g,  // Regex for replacing addition symbol with a space
		search = /([^&=]+)=?([^&]*)/g,
		decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
		query  = window.location.search.substring(1);

		urlParams = {};
		while (match = search.exec(query))
			urlParams[decode(match[1])] = decode(match[2]);


	return urlParams;
}

$(document).ready(function() {
	$("#logout").click(function() {
		sessionStorage.removeItem("filterFields");
	});
	
	var timeoutLoader = "";
	$(".loadingModal").on('click',function(event){        
	    var currentElement = $(this);        
	    $('.loadingText').text(currentElement.data('text'));               
		$('#loadingModal').modal({ backdrop: 'static', keyboard: false });
		timeoutLoader = setTimeout(function() {loadingModalError();}, 120000);
	}); 
	function loadingModalError(){
	  $('#loadingModal .ajaxloader').hide();
	  $('#loadingModal .loadingText').text('');
	  $('#loadingModal .modal-footer').show();
	  $('#loadingModal .loadingMessage').text('Er is een fout opgetreden tijdens het laden');
	}
	$('#loadingModal').on('hide.bs.modal',function() {
	  clearTimeout(timeoutLoader);
	  $('#loadingModal .ajaxloader').show();
	  $('#loadingModal .modal-footer').hide();
	  $('#loadingModal .loadingMessage').text('Laden');
	});
});

$('.epform').on('submit', function(){
	var me = $(this);
	me.find('[type="submit"]').addClass('loading').prop("disabled", true)

	setTimeout(function(){
		me.find('[type="submit"]').removeClass('loading').removeAttr("disabled")
	}, 1000)
})